module.exports = __webpack_public_path__ + "static/media/track.4f232f6e.svg";